import { uiNamespace } from '@backoffice-frontend/common'
import { useErrorHandlingMutation } from '@backoffice-frontend/data-fetching'
import type { BackofficeUser } from '@backoffice-frontend/graphql'
import { useMoiaErrorNotification } from '@backoffice-frontend/patterns'
import { Button } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'
import store from 'store'
import { useBackofficeUserManagementSwapGroupsMutation } from './swapUserWithGroups.hook'

const GROUP_SWITCHER_FALLBACK = `${uiNamespace}.groupSwitcherReset`
export const persistUser = (
  backofficeUser?: Partial<BackofficeUser>,
  initialGroups?: string[],
) => {
  if (initialGroups) {
    return
  }
  if (backofficeUser?.timedGroups) {
    store.set(
      GROUP_SWITCHER_FALLBACK,
      backofficeUser.timedGroups.map(timed => timed?.groupName),
    )
  }
}

export const ResetUserButton = ({
  handleRefreshToken,
  initialGroups,
}: {
  handleRefreshToken: () => Promise<void>
  initialGroups: string[]
}) => {
  const { t } = useTranslation()
  const { enqueueMoiaErrorNotification } = useMoiaErrorNotification()
  const [resetUser] = useErrorHandlingMutation(
    useBackofficeUserManagementSwapGroupsMutation,
  )
  const handleResetGroups = async () => {
    const groupsList: string[] | undefined = initialGroups
    if (!groupsList) {
      enqueueMoiaErrorNotification('No user persisted yet try to reload')
      return
    }
    const response = await resetUser({
      variables: {
        input: {
          groupName: null,
          groupsList,
        },
      },
    })
    if (response.data?.backofficeUserManagementSwapGroups) {
      await handleRefreshToken()
    }
  }
  return (
    <Button
      label={t('common_reset_label')}
      onClick={handleResetGroups}
      variant="secondary"
      size="compact"
    />
  )
}
